import axios from 'axios';

export default function getSession() {
	return axios.get('/api/passport/session');
}
